<template>
  <InlineSvg
    :src="src"
    class="svg-icon"
    :class="{ active }"
    :width="width"
    :height="height" />
</template>

<script>
import InlineSvg from 'vue-inline-svg'
export default {
  components: {
    InlineSvg
  },
  props: {
    src: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: 24,
    },
    height: {
      type: [String, Number],
      default: 24,
    }
  }

}
</script>

<style lang="scss" scoped>
.svg-icon {
  fill: currentColor;

  &.active {
    color: $l-blue;
  }
}
</style>